import styled from "styled-components";

export const HomeContainer = styled.div`
    min-height: 100vh;
    display: flex;
    padding: 50px;
   
`